<template>
    <div id="racePage">
        <v-container justify-center>
            <v-row>
                <v-col cols="12" sm="12">
                    <v-card>
                        <v-row class="no-gutters">
                            <v-col cols="12" sm="10" class="offset-sm-1 ">
                                <div class="d-flex align-top">
                                    <v-img max-height="200" contain :src="leagues.leagueBanner"></v-img> 
                                </div>    
                            </v-col>
                        </v-row>
                        <!-- <v-row class="no-gutters">
                            <v-col cols="10" class="offset-1">
                                <h1>{{ leagues[leagueId].races[raceId].raceName }}</h1>
                            </v-col>
                        </v-row>
                        <v-row class="no-gutters">
                            <v-col cols="10" class="offset-1">
                                <h2>Liga: {{ leagues[leagueId].leagueName}}</h2>
                            </v-col> 
                        </v-row> -->
                        <v-row class="no-gutters text-uppercase">
                            <v-col cols="12" sm="10" class="offset-sm-1 mt-2 mb-2">
                                <div class="d-flex justify-center headline">Dane wyścigu</div>
                            </v-col>
                        </v-row>
 <!-- listowanie danych wyścigu -->
                        <!-- <v-row class="justify-center">
                            <v-col cols="10">
                                <v-list-item>
                                    <v-list-item-content class="text-uppercase">
                                        <v-list-item-title class="text-wrap">Dane wyścigu: {{ leagues[leagueId].races[raceId].raceName }}</v-list-item-title>
                                        <v-list-item-subtitle class="text-wrap">Liga: {{ leagues[leagueId].leagueName}}</v-list-item-subtitle>
                                        <v-list-item-subtitle>Data: {{leagues[leagueId].races[raceId].raceDate}}</v-list-item-subtitle>
                                        <v-list-item-subtitle class="text-wrap">Dane wyścigu: {{ leagues[leagueId].races[raceId].raceName }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row> -->
                        <v-row class="no-gutters pb-2" v-if="races.beforeRaceDate">
                            <v-col cols="12" sm="10" md="4" class="offset-sm-1 offset-md-2 d-flex flex-column">
                                <div class="ma-1 d-flex justify-start">Liga: <span class=" text-uppercase">{{ leagues.leagueName}}</span></div>
                                <div class="ma-1 d-flex justify-start">Data:  <span class=" text-uppercase">{{ races.raceDate}}</span></div>
                                <div class="ma-1 d-flex justify-start">Dane wyścigu:  <span class=" text-uppercase">{{ races.raceName }}</span></div>
                                <div class="ma-1 d-flex justify-start"> Miejsca <v-icon class="ml-2 mr-1">supervisor_account</v-icon>:  <span class=" text-uppercase">{{ races.amountOfSlots }}</span></div>
                                <div class="ma-1 d-flex justify-start">Pozostałe miejsca <v-icon class="ml-2 mr-1">group_add</v-icon> :  <span class=" text-uppercase">{{ races.availableDriverSlots }}</span></div>
                                <div class="ma-1 d-flex justify-start">Length of loop <v-icon class="ml-2 mr-1">fa-road</v-icon> :  <span class=" text-uppercase">{{ races.loopLenght }}</span> km</div>
                                <div class="ma-1 d-flex justify-start">Time per stage <v-icon class="ml-2 mr-1">alarm</v-icon> :  <span class=" text-uppercase">{{ races.timePerStage }}</span> min</div>
                                <div class="ma-1 d-flex justify-start">Ticket price <v-icon class="ml-2 mr-1">fa-money-bill-wave</v-icon>:  <span class=" text-uppercase">{{ races.lowerPrice ? races.tickerPrice : races.preTicketPrice}}</span> pln </div>
                            </v-col>
                            <v-col cols="12" sm="10" md="4" class="offset-sm-1 offset-md-0 d-flex flex-column">
                                <div height="100%" class="text-center"> 
                                    <l-map
                                    :zoom="zoom"
                                    :center="races.location"
                                    style="min-height: 250px; width: 100%"
                                    >
                                    <l-tile-layer :url="url" :attribution="attribution"/>
                                    <l-marker :lat-lng="races.location">
                                    </l-marker>
                                    </l-map>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="no-gutters pb-2" v-if="races.showDescription">
                            <v-col cols="12" sm="10" md="8" class="offset-sm-1 offset-md-2">
                                <div class="ma-1 d-flex justify-center title  text-uppercase">
                                    Opis
                                </div>
                                <div class="ma-1 d-flex jutify-center subtitle">
                                    {{races.raceDescription}}
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="no-gutters text-uppercase pb-3">
                            <v-col cols="12" sm="8" class="offset-sm-2">
                                <div class="justify-center d-flex">
                                    <v-btn
                                        v-if="races.availableSlots && !overRaceDate"
                                        class="ma-2 white--text"
                                        :loading="loading2"
                                        :disabled="loading2"
                                        color="#76EB6C"
                                        x-large
                                        width="100%"
                                        @click="loader = 'loading2'"
                                        >
                                        <span>Kupuję</span>
                                        <v-icon right>fa-flag-checkered</v-icon>
                                        
                                        <template v-slot:loader>
                                            <span>Loading...</span>
                                        </template>
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        class="ma-2 white--text"
                                        :disabled="!races.availableSlots || overRaceDate"
                                        color="#76EB6C"
                                        x-large
                                        width="100%"
                                        >
                                        <span v-if="!races.availableSlots">Bark miejsc</span>
                                        <span v-else>Wyścig już się odbył</span>
                                        <v-icon right>fa-flag-checkered</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { LMap, LTileLayer, LMarker} from 'vue2-leaflet';
export default {
    name:'racePage',
    components: {
        LMap,
        LTileLayer,
        LMarker
    },
    data(){
        return{       
            zoom:12,
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            leagueId: parseInt(this.$route.params.league_id),
            raceId: parseInt(this.$route.params.race_id),
            loader:null,
            loading2:false,
        }
    },
    computed:{
        leagues(){
            return this.$store.getters.getLeague(this.leagueId);
        },
        // league(){
        //     return this.$store.state.leagues[this.leagueIndex];
        // },
        races(){
            return this.$store.getters.getRace(this.leagueId,this.raceId);
        },
        // race(){
        //     return this.$store.state.leagues[this.leagueIndex].races[this.raceIndex];
        // },
        overRaceDate(){
            return false;
        }
    },
    methods:{
    },
    watch: {
        loader () {
            const l = this.loader
            this[l] = !this[l]

            setTimeout(() => (this[l] = false), 3000)

            this.loader = null
        },
    },
    mounted(){
        if(this.$store.state.leagues.length==0){
            this.$store.dispatch('fetchLeagueData')
        }
    }
}
</script>
<style scoped>
    .text-wrap{
        white-space: normal !important;
    }
    .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
</style>